export default "__VITE_ASSET__DZw07xrn__"